import { defineStore } from 'pinia';
import axios from 'axios';

function preloadState() {
  return window.__PRELOAD_STATE__ ?? {};
}

export const useStore = defineStore({
  id: 'cadastro',

  state: () => {
    const initial = preloadState();
    return {
      driverId: '',
      shopeeFlow: 'optional',
      preRegistrationData: {
        name: '',
        cpf: '',
        email: '',
        mobile_number: '',
        password: '',
        password_confirm: '',
        vehicle_type: '',
        shopee_station_id: '',
        shopee_registered_different_agency: ''
      },
      steps: {
        completed: '',
        bank_data: '',
        personal_data: '',
        vehicle_data: '',
        documents: ''
      },
      statements: {
        declaracao_cnh:'',
        declaracao_renavam: '',
      },
      bankData: {
        bank_code: '',
        cnpj: '',
        bank_branch_number: '',
        bank_branch_digit: '',
        bank_account_number: '',
        bank_account_digit: '',
        bank_account_pix_key: '',
      },
      personalData: {
        birthdate: '',
        rg_fathers_name: '',
        rg_mothers_name: '',
        gender: '',
        address_postal_code: '',
        address_thoroughfare: '',
        address_neighborhood: '',
        address_number: '',
        address_complement: '',
        address_state: '',
        address_locality: ''
      },
      personalDataFiles: {

      },
      vehicleData: {
        vehicle_plate: '',
        vehicle_plate_state: '',
        vehicle_plate_city: '',
        vehicle_identification_number: '',
        vehicle_renavam: '',
        vehicle_certificate: '',
        vehicle_model_name: '',
        vehicle_color: '',
        vehicle_build_year: '',
        vehicle_model_year: ''
      },
      vehicleFiles: {

      },
      documentationsData: {
        cnh_category: '',
        cnh_numero_espelho: '',
        cnh_registration_number: '',
        cnh_issue_city: '',
        cnh_issue_city_ibge_code: '',
        cnh_issuer_state: '',
        cnh_first_license_date: '',
        cnh_renach: '',
      },
      documentationFiles: {

      },
      banksList: [],
      ...initial
    };
  },
  actions: {
    async fetchHubs(){
      this.isLoading = true;
      const url = `/_api_proxy/drivers/hubs`;
      try {
        const response = await axios.get(url);
        this.hubsList = response.data;
      }catch (error) {
        console.error('Erro ao buscar hubs:', error);
      }
    },
    async fetchBanks() {
      this.isLoading = true;
      const url = `/_api_proxy/drivers/banks`;
      try {
        const response = await axios.get(url);
        this.banksList = response.data;
      } catch (error) {
        console.error('Erro ao buscar bancos:', error);
      }
    },
    async fetchDriver() {
      this.isLoading = true;
      console.log(`DriverId na this: ${this.driverId}`); // Adicione este log

      const url = `/_api_proxy/drivers-v2/drivers/${this.driverId}`;
      try {
        const response = await axios.get(url);
        console.log("Response steps: ", response.data.registration_steps);

        this.updateSteps(response.data.registration_steps);
      } catch (error) {
        console.error('Erro ao buscar driver:', error);
      }
    },
    updatePreRegistrationData(formData) {
      this.preRegistrationData = { ...this.preRegistrationData, ...formData };
    },
    updateBankData(formData) {
      this.bankData = { ...this.bankData, ...formData };
    },
    updatePersonalData(formData) {
      this.personalData = { ...this.personalData, ...formData };
    },
    updatePersonalDataFileStatus(objectFile, statusUpload) {
      this.personalDataFiles[objectFile] = {
        ...this.personalDataFiles[objectFile],
        statusUpload: statusUpload
      }},
    updatePersonalDataFile(objectFile, isFirstUpload) {
      this.personalDataFiles[objectFile] = {
        ...this.personalDataFiles[objectFile],
        isFirstUpload: isFirstUpload
      }},
    updateVehicleData(formData) {
      this.vehicleData = { ...this.vehicleData, ...formData };
    },
    updateVehicleFileStatus(objectFile, statusUpload) {
      this.vehicleFiles[objectFile] = {
        ...this.vehicleFiles[objectFile],
        statusUpload: statusUpload
      }},
    updateVehicleFile(objectFile, isFirstUpload) {
      this.vehicleFiles[objectFile] = {
        ...this.vehicleFiles[objectFile],
        isFirstUpload: isFirstUpload
      }},
    updateDocumentationsData(formData) {
      this.documentationsData = { ...this.documentationsData, ...formData };
    },
    updateDocumentationFileStatus(objectFile, statusUpload) {
      this.documentationFiles[objectFile] = {
        ...this.documentationFiles[objectFile],
        statusUpload: statusUpload
      }},
    updateDocumentationFile(objectFile, isFirstUpload) {
      this.documentationFiles[objectFile] = {
        ...this.documentationFiles[objectFile],
        isFirstUpload: isFirstUpload
      }},
    setDriverId(id) {
      this.driverId = id;
    },
    registrationCompleted() {
    },
    updateSteps(steps) {
      this.steps = steps;
    },
    updateStatements(formData) {
      this.statements = { ...this.statements, ...formData };
    }
  },
  getters: {
    getRegistrationData() {
      return this.preRegistrationData;
    },
    getBankData() {
      return this.bankData;
    },
    getPersonalData() {
      return this.personalData;
    },
    getPersonalDataFile() {
      return this.personalDataFiles;
    },
    getVehicleData() {
      return this.vehicleData;
    },
    getVehicleFile() {
      return this.vehicleFiles;
    },
    getDocumentationsData() {
      return this.documentationsData;
    },
    getDocumentationFile() {
      return this.documentationFiles;
    },
    getSteps() {
      return this.steps;
    },
    getDriverId() {
      return this.driverId;
    },
    isAllStepsCompleted() {
      return this.steps.bank_data && this.steps.personal_data && this.steps.vehicle_data && this.steps.documents;
    },
    getStatements() {
      return this.statements;
    }
  }
});
